module.exports = __webpack_public_path__ + "img/IMG_9786_L.579954d8.webp";